import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import GameSwitcher from './GameSwitcher';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const goToSection = (sectionId: string) => {
    setIsMenuOpen(false);
    if (isHome) {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      // After navigation, scroll to section once DOM is ready
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  const navLinkClass = "relative text-gray-300 hover:text-red-400 transition-all duration-200 cursor-pointer whitespace-nowrap after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-0.5 after:bg-red-500 after:transition-all after:duration-200 hover:after:w-full";
  const mobileLinkClass = "text-gray-300 hover:text-red-400 transition-colors duration-200 text-left cursor-pointer whitespace-nowrap";

  const sections = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'server-info', label: 'Server Info' },
    { id: 'perks', label: 'Perks' },
    { id: 'vip', label: 'VIP', icon: 'ri-vip-crown-2-line' },
    { id: 'rules', label: 'Rules' },
    { id: 'team', label: 'Team' },
    { id: 'news', label: 'News' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-red-900/30">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Network switcher + site home */}
          <div className="flex items-center space-x-2">
            <GameSwitcher currentId="kf1" />
            <Link to="/" className="flex flex-col leading-none hover:opacity-90 transition-opacity">
              <span className="font-orbitron text-sm font-black tracking-wide text-red-500">ULIUNAI</span>
              <span className="font-rajdhani text-[11px] font-bold uppercase tracking-[0.2em] text-white/70">
                Killing Floor
              </span>
            </Link>
          </div>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center space-x-8">
            {sections.map(s => (
              <button key={s.id} onClick={() => goToSection(s.id)} className={navLinkClass}>
                {s.icon && <i className={`${s.icon} mr-1`}></i>}{s.label}
              </button>
            ))}
            <Link to="/stats" className={navLinkClass}>
              Stats
            </Link>
            <LanguageSwitcher />
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-red-900/30">
            <div className="flex flex-col space-y-4">
              {sections.map(s => (
                <button key={s.id} onClick={() => goToSection(s.id)} className={mobileLinkClass}>
                  {s.icon && <i className={`${s.icon} mr-1`}></i>}{s.label}
                </button>
              ))}
              <Link to="/stats" onClick={() => setIsMenuOpen(false)} className={mobileLinkClass}>
                Stats
              </Link>
              <LanguageSwitcher compact />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
